/**
 * GAMIFICATION (F4) — i18n labels for opt-in BADGES/achievements.
 *
 * `gamification-core` is render-agnostic: each badge carries a `title` that is
 * a stable key (`badge.*`, see `packages/shared/src/domain/gamification.ts`).
 * The translation lives HERE, in the web layer, following the repo convention
 * (auto-id from source text, `msg\`…\`` + `t(...)`), and NOT in `shared` (which
 * does not depend on lingui). Add one entry per badge in the catalogue.
 */
import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

/** `badge.*` key (or badge id) → translatable es/en descriptor. */
const BADGE_LABELS: Record<string, MessageDescriptor> = {
  "devotional-first": msg`First devotional complete`,
  "devotional-streak-7": msg`7-day devotional streak`,
  "devotional-streak-30": msg`30-day devotional streak`,
  "service-member": msg`Serving in a ministry`,
  "service-faithful-10": msg`Faithful servant · 10 services`,
};

/**
 * Resolves the translatable label of a badge by its id (or its
 * `badge.<id>` key). Returns the raw id when there is no label (new badge not
 * translated yet) so the render never breaks.
 */
export function badgeLabel(t: (descriptor: MessageDescriptor) => string, badgeId: string): string {
  const key = badgeId.startsWith("badge.") ? badgeId.slice("badge.".length) : badgeId;
  const descriptor = BADGE_LABELS[key];
  return descriptor ? t(descriptor) : badgeId;
}
